import { requestInvite } from '../../actions/passwordReset';
import RequestLinkForm from './RequestLinkForm';

export default function Activate() {
  return (
    <RequestLinkForm
      thunk={requestInvite}
      side={{
        eyebrow: 'Account activation',
        headline: 'Welcome back — let’s set up your account.',
        paragraph:
          'Migrated from a legacy or lifetime plan? Enter your email and we’ll send a setup link so you can create a password and access your sites.',
      }}
      bracket="[ Account · Activation ]"
      headline="Activate your account."
      lede="Enter your account email and we’ll send a setup link so you can set your password. The link is valid for 7 days."
      emailHint="Use the email associated with your legacy account."
      ctaLabel="Send setup link →"
      confirmTitle="Check your inbox."
      confirmBody="If your account is eligible, a setup link is on its way."
      confirmNote="The link is valid for 7 days. Don’t see it? Check your spam folder, then resend below."
    />
  );
}
